import script from "./AlbumDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumDetail.vue?vue&type=script&setup=true&lang=js"

import "./AlbumDetail.vue?vue&type=style&index=0&id=19012fb1&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19012fb1"]])

export default __exports__